<div id="control-menu" class="control-menu" [ngClass]="'menuClass'">
  <nav id="commandbar-wrapper" class="ft-navbar ft-navbar-default" role="navigation">

    @if (displayState.showCommandBar) {
    <div class="objectnavbar-item-left">

      <!--Save button-->

      @if (isDirty && !isSaving) {
      <button type="button" mat-icon-button color="primary"
          (click)="save()"
          class="hidden-print commandbar-item material-icons blink ft-save-button"
         
          tooltip-placement="bottom" tooltip="Save" title="Save Document (Ctrl+S)"
          id="buttonSave">
          <mat-icon>check</mat-icon>
      </button>
      }

      <!--Spinner button-->
      @if (showSpinner) {
      <div class="spinner-wrap" id="spinnerIcon">
        <div class="commandbar-spinner"></div>
      </div>
     }

      <div class="commandbar-buttons" >

        @if (displayState.showTemplateName) {
        <ft-template-name></ft-template-name>
        }
        <!--Upload document image button-->
        @if (displayState.showCameraButton) {
        <ft-command-bar-uploader></ft-command-bar-uploader>
        }

        <div class="commandbar-item-others">
          <!--Print button-->
          @if (displayState.showPrintButton) {
          <ft-print class="commandbar-item-others.print">
          </ft-print>
          }

          <!--Create new button-->
          @if (displayState.showCreateButton) {
          <button type="button" mat-icon-button color="primary"
                  aria-label="Create  New document"
                  (click)="createNewDocument()"
                  class="hidden-print commandbar-item material-icons ft-create-new"
                 
                  tooltip-placement="bottom" tooltip="New" title="New document"
                  id="buttonNew">

            <mat-icon>note_add</mat-icon>

          </button>
          }

          <!--Delete button-->
          @if (displayState.showDeleteButton) {
          <ft-delete></ft-delete>
          }
        </div>
      </div>
    </div>
    }

    <!--Summary name-->
    @if (displayState.showSummaryName) {
    <div class="summaryName-wrapper">
      @if (summaryName !== 'none') {
            <span
              matTooltip="{{summaryName}}"
              class="summaryName text-ellipsis ft-navbar-text mat-title">
                {{summaryName}}
                @if (documentData?.document?.systemHeader?.currentVersion === false) {
                <button type="button" mat-icon-button color='primary'
                        title="*PREVIOUS VERSION*"
                       
                        (click)="popupVersionMessage(documentData.document)"
                        aria-label='Previous Version'>
                        <mat-icon>date_range</mat-icon>
                </button>
                }
            </span>
      }
    </div>
    }

  </nav>
</div>
